import * as React from 'react';
import { ModalButton } from '@components/modalButton/ModalButton';
import { EnhancedExportButton } from '@components/exportButton/ExportButton';

import { DogsGeovapModal } from '@modules/dogs/DogsGeovapModal';

const DogsActionBar = ({
  doglust,
  refresh,
  state: { sort, order, page, pageSize, filters, checkedItems, universalFilter }
}) => {
  const params = { sort, order, page, pageSize, filters, checkedItems, universalFilter };
  return (
    <React.Fragment>
      <EnhancedExportButton location={'dogOverview'} params={params} />
      {doglust === 'geopa' && (
        <ModalButton
          label="Zkontrolovat psa"
          ModalComponent={DogsGeovapModal}
          style={{ marginLeft: 5, marginBottom: 10, marginRight: 10 }}
          dialogStyles={{
            style: { paddingTop: '5vh' },
            contentStyle: {
              paddingTop: 10,
              transform: 'none'
            },
            bodyStyle: { padding: '0', overflow: 'auto' }
          }}
          onSave={refresh}
        />
      )}
    </React.Fragment>
  );
};

export default DogsActionBar;



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsActionBar.tsx